// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__YJPlC","ui":"styles_ui__A7dmQ","text":"styles_text__79HbF"};